/**
 * A failed provider return arrives as `?error=<code>` and sometimes
 * `&error_description=<text>`. The shell reads only the code; the description
 * is never read. This is the current location without either, with every other
 * parameter and the hash kept.
 */
export function withoutSignInError(href: string): string {
  const url = new URL(href);
  url.searchParams.delete('error');
  url.searchParams.delete('error_description');
  return `${url.pathname}${url.search}${url.hash}`;
}

/**
 * Takes a failed provider return out of the address: answers its code (null
 * when the address carries none) and replaces the current history entry with
 * the same address without `error` and `error_description`. Nothing is loaded
 * again and the entry keeps its state. A second call finds nothing, so the code
 * is read once.
 */
export function takeSignInError(location: Pick<Location, 'href'>, history: Pick<History, 'replaceState' | 'state'>): string | null {
  const parameters = new URL(location.href).searchParams;
  if (!parameters.has('error') && !parameters.has('error_description')) return null;
  const code = parameters.get('error');
  history.replaceState(history.state, '', withoutSignInError(location.href));
  return code;
}
